<template>
	<!-- <v-expansion-panels v-if="filteredBookings && filteredBookings[0] && filteredBookings[0] !== '0'"> -->
	<v-expansion-panels v-if="incompleteForms.length > 0">
      <v-expansion-panel
        v-for="(itemPanel,i) in 1"
        :key="i"
      >
		<v-expansion-panel-header>
			{{txt.expansionPanelHeaderPre}} {{calculateIncompleteEntries}} {{txt.expansionPanelHeader}}
			<template v-slot:actions>
				<v-icon color="error">
					mdi-alert-circle
				</v-icon>
			</template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-list flat color="orange">
				<p v-for="(item) in incompleteForms" >
				<v-list-item-content>
					{{txt.fromId}}: {{item.form_id}},
					{{txt.status}}: {{item.registration_status}},
					{{txt.personId}}: {{item.person_id}}
				</v-list-item-content>
				</p>
			</v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
	</v-expansion-panels>
</template>

<script>
export default {
	name: 'incompleteForms',
	props: {
		bookings: {
			required: true,
		},
		incompleteForms: {
			required: true,
		},
	},
	data() {
		return {
			txt: {
				// eslint-disable-next-line max-len
				expansionPanelHeaderPre: 'Found',
				expansionPanelHeader: `
					forms with missing age group (possible inaccuracies at overnight stays per age group). 
					This results from a non-complete state of the registration form.`,
				fromId: 'From id',
				status: 'status',
				personId: 'person id',
			},
		}
	},
	computed: {
		calculateIncompleteEntries() {
			const non = this.bookings
				.map((x) => x.incomplete_entries)
				.filter((x) => Number(x) !== 0)
				// eslint-disable-next-line no-return-assign
				.reduce((acc, val) => acc += Number(val), 0)
			return non
		},
	},

}
</script>

<style>

</style>
